module.exports = __webpack_public_path__ + "cxptaingrayson.jpg?b53dc7e228faacf6e5eb5db61811172f";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/cxptaingrayson.jpg
// module id = 618
// module chunks = 0